import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useReactlytics } from '@americanexpress/reactlytics';
import { SmallDropdown } from '@americanexpress/consumer-travel-base';
import { useConditionalFeature } from '@americanexpress/conditional-features';
import { MODULE_NAME, BUNDLE_TYPES } from '../../../constants/packagesConstants';
import { getBundleType } from '../../../selectors/filtersSelectors';
import setBundleTypeThunk from '../../../thunks/setBundleTypeThunk';
import themeContext from '../../../context/themeContext';
import { hasBundleTypeDropdownRule } from '../../../constants/ruleConstants';

const BundleTypeDropdown = () => {
  const theme = useContext(themeContext);
  const { formatMessage } = useIntl();
  const { track } = useReactlytics();
  const bundleType = useSelector(getBundleType);
  const hasBundleTypeDropdown = useConditionalFeature(hasBundleTypeDropdownRule);
  const dispatch = useDispatch();
  const handleChange = (newBundleType) => {
    track({
      event: {
        element: newBundleType
          .toLowerCase()
          .replace(/_/g, '-'),
        identifier: MODULE_NAME,
      },
    });
    dispatch(setBundleTypeThunk(newBundleType));
  };

  if (!hasBundleTypeDropdown) {
    return null;
  }

  return (
    <div className="col-lg-3 col-sm-6 col-xs-12 flex">
      <SmallDropdown
        id="bundleTypeDropdown"
        ariaLabel={formatMessage({ id: 'bundleTypeDropdown.ariaLabel' })}
        theme={theme}
        value={bundleType}
        onChange={handleChange}
        options={[
          {
            label: formatMessage({ id: 'air_and_hotel' }),
            value: BUNDLE_TYPES.AIR_HOTEL,
          },
          {
            label: formatMessage({ id: 'air_and_car' }),
            value: BUNDLE_TYPES.AIR_CAR,
          },
          {
            label: formatMessage({ id: 'air_hotel_and_car' }),
            value: BUNDLE_TYPES.AIR_HOTEL_CAR,
          },
        ]}
      />
    </div>
  );
};

export default BundleTypeDropdown;
